export default __webpack_public_path__ + "static/media/speer_logo_footer_purple.54b20470.svg";